//动物类型
export const animalTypeOptions = [
  {value: '肉鸡',label: '肉鸡',children: [{value: '白羽',label: '白羽'},{value: '有色羽',label: '有色羽',}]},
  {value: '肉鸭',label: '肉鸭',children: [{value: '白羽',label: '白羽'},{value: '有色羽',label: '有色羽',}]},
]
//动物
export const animalTypeList = [
  {
    id:1,name: '肉鸡',VarietyDepotCode:'meatTypeChickens',LabelCode:'positiveMeatChickens',
    feedPhaseList:[{id:1, name: '三阶段'}, {id:2, name: '四阶段'}],
    feedModeList:[
      {id:1, name: '笼养'}, {id:2, name: '高网'},
      {id:3, name: '地面网养'}, {id:4, name: '地面散养'}
    ],
  },
  {
    id:2,name: '肉鸭',VarietyDepotCode:'meatTypeDucks',LabelCode:'positiveMeatDucks',
    feedPhaseList:[{id:1, name: '二阶段'}, {id:2, name: '三阶段'}],
    feedModeList:[
      {id:1, name: '笼养'}, {id:2, name: '高网'},
      {id:3, name: '全地网'}, {id:4, name: '半地网'},
      {id:5, name: '地面（无网）'}, {id:6, name: '水养'}
    ]
  }
]
//出栏方式
export const outTypeList = [
  {id:1,name:'棚前称重'},
  {id:2,name:'杀胴体'}
]
//打分情况
export const scoreList = [
  {id:1,name:'1分'},
  {id:2,name:'2分'},
  {id:3,name:'3分'},
  {id:4,name:'4分'},
  {id:5,name:'5分'},
  {id:6,name:'6分'},
  {id:7,name:'7分'},
  {id:8,name:'8分'},
  {id:9,name:'9分'},
  {id:10,name:'10分'},
  {id:11,name:'11分'},
  {id:12,name:'12分'},
  {id:13,name:'13分'},
]
//养殖场性质
export const farmPropertiesList = [
  {farmPropertiesId:1,farmPropertiesName:'散养'},
  {farmPropertiesId:2,farmPropertiesName:'规模场'}
]
